import React, { Suspense, lazy, useEffect } from "react";
import TopNav from "../components/landing/TopNav";
import Hero from "../components/landing/Hero";
import HowItWorks from "../components/landing/HowItWorks";

// Lazy-load below-the-fold sections so the hero paints as fast as possible.
const Features = lazy(() => import("../components/landing/Features"));
const UseCases = lazy(() => import("../components/landing/UseCases"));
const Safety = lazy(() => import("../components/landing/Safety"));
const Testimonials = lazy(() => import("../components/landing/Testimonials"));
const FAQ = lazy(() => import("../components/landing/FAQ"));
const FinalCTA = lazy(() => import("../components/landing/FinalCTA"));
const Footer = lazy(() => import("../components/landing/Footer"));

function SectionSkeleton() {
    return (
        <div
            aria-hidden="true"
            className="w-full py-20"
            style={{
                minHeight: 480,
                contentVisibility: "auto",
                containIntrinsicSize: "480px",
            }}
        />
    );
}

export default function Landing() {
    useEffect(() => {
        document.title = "BetweenUs — A calmer way through conflict";
    }, []);

    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen bg-paper text-ink"
        >
            <TopNav />
            <Hero />
            <HowItWorks />
            <Suspense fallback={<SectionSkeleton />}>
                <Features />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <UseCases />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <Safety />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <Testimonials />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <FAQ />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <FinalCTA />
            </Suspense>
            <Suspense fallback={<SectionSkeleton />}>
                <Footer />
            </Suspense>
        </main>
    );
}
